import type { PagedIssuesByAssigneeType, PagedIssuesByTypeType } from './types.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformIssuesByAssigneeData = (data: any): PagedIssuesByAssigneeType => ({
	pageInfo: {
		hasNextPage: data.pageInfo.hasNextPage,
		endCursor: data.pageInfo.endCursor,
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	data: data.nodes.map((node: any) => ({
		id: node.id,
		user: node.field.userValue
			? {
					avatarUrl: node.field.userValue.avatarUrl ?? '',
					displayName: node.field.userValue.displayName,
					accountId: node.field.userValue.accountId,
				}
			: null,
		count: node.totalCount,
	})),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformIssuesByTypeData = (data: any): PagedIssuesByTypeType => ({
	pageInfo: {
		hasNextPage: data.pageInfo.hasNextPage,
		endCursor: data.pageInfo.endCursor,
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	data: data.nodes.map((node: any) => ({
		id: node.id,
		issueType: node.field
			? {
					iconUrl: node.field.iconUrl,
					name: node.field.name,
					id: node.field.id,
				}
			: null,
		count: node.totalCount,
	})),
});
